import React from 'react';
import PropTypes from 'prop-types';

import styles from './svg.scss';

const Svg = ({ src, className }) => (
  // The only nice way to load svgs inline in react is dangerous
  // eslint-disable-next-line react/no-danger
  <div dangerouslySetInnerHTML={{ __html: src }} className={`${className} ${styles.svg}`} />
);

Svg.propTypes = {
  src: PropTypes.string.isRequired,
  className: PropTypes.string,
};

Svg.defaultProps = {
  className: null,
};

export default Svg;



// WEBPACK FOOTER //
// ./common/components/Svg/index.js